/** Native metadata is the same decoder authority used for alpha canvas frames. */
export function measureBrowserAlphaVideoDuration(src:string,signal:AbortSignal):Promise<number>{
  return new Promise((resolve,reject)=>{
    if(signal.aborted){reject(signal.reason);return;}
    const video=document.createElement('video');
    video.crossOrigin='anonymous';video.muted=true;video.preload='metadata';video.playsInline=true;
    let finished=false;
    const cleanup=()=>{
      clearTimeout(timer);
      video.removeEventListener('loadedmetadata',onMetadata);
      video.removeEventListener('error',onError);
      signal.removeEventListener('abort',onAbort);
      try{video.pause();video.removeAttribute('src');video.load();}catch{/* release still settles */}
    };
    const finish=(seconds?:number,error?:Error)=>{
      if(finished)return;finished=true;cleanup();
      error?reject(error):resolve(seconds!);
    };
    const onMetadata=()=>{
      const seconds=video.duration;
      if(!Number.isFinite(seconds)||seconds<=0)
        finish(undefined,Error('투명 영상의 반복 길이를 읽지 못했습니다. 원본 파일을 확인해 주세요.'));
      else finish(seconds);
    };
    const onError=()=>finish(undefined,Error('투명 영상의 반복 길이를 읽지 못했습니다. 원본 파일을 확인해 주세요.'));
    const onAbort=()=>finish(undefined,signal.reason instanceof Error?signal.reason:Error('투명 영상 길이 측정이 중단됐습니다.'));
    const timer=setTimeout(()=>finish(undefined,Error('투명 영상의 반복 길이 측정 시간이 초과됐습니다.')),15_000);
    video.addEventListener('loadedmetadata',onMetadata,{once:true});
    video.addEventListener('error',onError,{once:true});
    signal.addEventListener('abort',onAbort,{once:true});
    try{video.src=src;video.load();}catch(error){finish(undefined,error instanceof Error?error:Error('투명 영상 길이 측정 실패'));}
  });
}
